export const SUBJECT_COLORS = [
  { match: "math", color: "#1976d2", tint: "#e8f1fb" },
  { match: "english", color: "#c2185b", tint: "#fbe9f0" },
  { match: "non-verbal", color: "#ff9800", tint: "#fff3e0" },
  { match: "non verbal", color: "#ff9800", tint: "#fff3e0" },
  { match: "verbal", color: "#8e24aa", tint: "#f3e8fb" },
];

export const AREA_BUCKETS = [
  { key: "weak_areas", label: "Needs Improvement", short: "Weak", bg: "#fee2e2", fg: "#dc2626" },
  { key: "medium_areas", label: "Keep Practicing", short: "Medium", bg: "#fef3c7", fg: "#d97706" },
  { key: "best_areas", label: "Outstanding", short: "Best", bg: "#dcfce7", fg: "#16a34a" },
];

export const subjectPalette = (name) => {
  const lower = String(name || "").toLowerCase();
  const hit = SUBJECT_COLORS.find((s) => lower.includes(s.match));
  return hit || { color: "#667eea", tint: "#eef0fd" };
};

/** Local YYYY-MM-DD. toISOString() would shift to UTC and bucket evening work into the wrong day. */
export const dayKey = (date) => {
  const d = new Date(date);
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${d.getFullYear()}-${month}-${day}`;
};

export const pct = (value) => {
  const n = Number(value);
  return Number.isFinite(n) ? Math.max(0, Math.min(100, Math.round(n))) : 0;
};

/** completed/total → bar % + Not started | In progress | Completed */
export const resourceProgress = (data) => {
  if (!data || data.total == null) {
    return { completed: null, total: null, percent: 0, fraction: "—", status: null, statusColor: "#95a5a6" };
  }
  const completed = Number(data.completed) || 0;
  const total = Number(data.total) || 0;
  const fraction = `${completed}/${total}`;
  if (total <= 0) {
    return { completed, total, percent: 0, fraction, status: "None", statusColor: "#95a5a6" };
  }
  if (completed <= 0) {
    return { completed, total, percent: 0, fraction, status: "Not started", statusColor: "#95a5a6" };
  }
  if (completed >= total) {
    return { completed, total, percent: 100, fraction, status: "Completed", statusColor: "#16a34a" };
  }
  return {
    completed,
    total,
    percent: (completed / total) * 100,
    fraction,
    status: "In progress",
    statusColor: "#d97706",
  };
};

export const sumResourceCounts = (rows, key) => {
  let completed = 0;
  let total = 0;
  let any = false;
  rows.forEach((row) => {
    const data = row.counts?.[key];
    if (!data) return;
    any = true;
    completed += Number(data.completed) || 0;
    total += Number(data.total) || 0;
  });
  return any ? { completed, total } : null;
};
